"use strict";

exports.__esModule = true;
exports.Header = Header;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _Breadcrumbs = require("../Breadcrumbs");
var _Heading = require("../Heading");
var _Text = require("../Text");
var _excluded = ["breadcrumbs", "title", "lead", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var HeaderWrapper = _styledComponents["default"].header.withConfig({
  displayName: "Header__HeaderWrapper",
  componentId: "sc-1txvgrf-0"
})(["padding:0.5rem 1rem;margin:0;color:", ";background:", ";border-bottom:1px solid ", ";"], (0, _Theme.val)("HeaderColor"), (0, _Theme.val)("HeaderBackground"), (0, _Theme.val)("HeaderBorderColor"));

/**
 * Displays a header for the top of a screen, panel or section.
 */
function Header(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    title = _ref.title,
    lead = _ref.lead,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(HeaderWrapper, extra, breadcrumbs && /*#__PURE__*/_react["default"].createElement(_Breadcrumbs.Breadcrumbs, {
    breadcrumbs: breadcrumbs
  }), title && /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 1
  }, title), lead && /*#__PURE__*/_react["default"].createElement(_Text.LeadText, {
    block: true
  }, lead), children);
}